/**
 * Controller: TemplatesCreatePricingCoupons
 */
angular.module('acme.application.templates.create.pricing.coupons.controllers', [
  'ui.bootstrap',
  'acme.common.service.api',
  'acme.common.service.templates',
  'acme.common.service.discounts',
  'acme.common.service.validate',
  'acme.common.service.helpers',
  'acme.common.factory.wizard',
  'acme.view.application.templates.showCouponsModal.controllers'
])
.controller('TemplatesCreatePricingCouponsController', [ '$scope', '$timeout', '$uibModal', 'ApiService', 'TemplatesService', 'DiscountsService', 'ValidateService', 'HelpersService', 'WizardFactory', '$window', function($scope, $timeout, $uibModal, ApiService, TemplatesService, DiscountsService, ValidateService, HelpersService, WizardFactory, $window) {

    $scope.templatesCreatePricingCoupons = {

      template: {},
      showModal: {},

      wizard: {},

      discountCodes: [],

      couponDiscounts: [],
      couponCategories: [],

      hasCouponDiscounts: false,
      areCouponDiscountsDirty: false,

      discountsLoaded: false,
      categoriesLoaded: false,

      init: function() {

        this.initWizard(true);

        ValidateService.addFieldTests(this.wizard.getStep('coupons').validators);

        $scope.$on('TemplatesService::Update', this.onTemplatesServiceUpdate);
        $scope.$on('DiscountsService::Update', this.onDiscountsServiceUpdate);
        
        $scope.$on('TemplatesCreateController::Save', this.onTemplatesCreateControllerSave);
        $scope.$on('TemplatesCreatePricing::Update', this.onTemplatesCreatePricingUpdate);

        this.getCouponCategories();
      },

      initWizard: function(validate) {
        var self = $scope.templatesCreatePricingCoupons;

        this.wizard = new WizardFactory();
        this.wizard.init({
          name: 'coupons',
          validators: [{
            field: 'templates-create-pricing-coupons-discount-loaded',
            equal: {
              message: 'Please wait...',
              test: function() {
                return [self.discountsLoaded, true];
              }
            }
          }, {
            field: 'templates-create-pricing-coupons-discount',
            equal: {
              message: 'You can have only one discount per coupon category',
              test: function() {
                return [TemplatesService.hasValidDiscounts(self.couponDiscounts, "couponCategory"), true];
              }
            }
          }, {
            field: 'templates-create-pricing-coupons-discount-selected',
            equal: {
              message: 'Please select a category and discount',
              test: function() {
                return [TemplatesService.hasDiscounts(self.couponDiscounts, "couponCategory"), true];
              }
            }
          }]
        });

        if (validate) {
          this.validate();
        }

      },

      validate: function() {
        this.wizard.validate();
        $timeout(function() {
          $scope.$emit('TemplatesCreatePricingController::TabCheck', {
            tab: 'coupons',
            invalid: $scope.templatesCreatePricingCoupons.wizard.hasErrors('coupons')
          });
        }, 0);
      },

      getCouponCategories: function() {
        this.categoriesLoaded = false;
        ApiService.coupons.categories.list(HelpersService.getPaginator()).then(this.success.getCouponCategories, this.error.getCouponCategories);
      },

      getCouponDiscounts: function() {
        this.discountsLoaded = false;
        if (!this.areCouponDiscountsDirty) {
          ApiService.coupons.templates.detail(this.template.id).then(this.success.getCouponDiscounts, this.error.getCouponDiscounts);
        }
      },

      findDiscountCode: function(id) {
        return DiscountsService.find(id);
      },

      checkCouponDiscounts: function() {
        if (this.couponDiscounts instanceof Array && this.couponDiscounts.length > 0) {
          this.hasCouponDiscounts = true;
        }else{
          this.hasCouponDiscounts = false;
        }
      },

      addCouponDiscount: function() {
        this.couponDiscounts.push({
          couponCategory: {},
          discountCode: {}
        });
        this.checkCouponDiscounts();
        this.areCouponDiscountsDirty = true;
      },

      removeCouponDiscount: function(index) {
        console.log('templatesCreatePricingCoupons::removeCoupon', index);

        this.couponDiscounts.splice(index, 1);
        this.checkCouponDiscounts();
        this.areCouponDiscountsDirty = true;
      },

      findCouponCategory: function(id) {
        var i, ii,
          r = false;

        for (i=0,ii=this.couponCategories.length;i<ii;i++) {
          if (id === this.couponCategories[i].id) {
            r = {
              index: i,
              category: this.couponCategories[i]
            };
            break;
          }
        }

        return r;
      },

      showCoupons: function(couponCategoryId) {
        var self = $scope.templatesCreatePricingCoupons;

        self.showModal = $uibModal.open({
          templateUrl: 'views/application/views/templates/modals/showCouponsModal.tpl.html',
          size: 'md',
          controller: 'TemplatesShowCouponsModalController',
          resolve: {
            CouponCategoryListData: function() {
              return ApiService.coupons.getCouponsByCategory(couponCategoryId, HelpersService.getPaginator());
            }
          }
        });

        // Invoked when modal completes with close(params)
        self.showModal.result.then(function() {
          // Do nothing
        }, function () {
          // Do nothing
        });
      },

      processCouponDiscounts: function(coupons) {
        var i, ii;

        // APP-5100: Diagnostic — detect when processCouponDiscounts is about to wipe existing
        // coupon discounts because the incoming payload is empty/null. This is a distinct
        // path from save_skipped: the data is destroyed in memory before any save occurs.
        var hasExistingCoupons = this.couponDiscounts instanceof Array && this.couponDiscounts.length > 0;
        var incomingIsEmpty = !coupons || coupons.length === 0;

        if (hasExistingCoupons && incomingIsEmpty) {
          var metadata = {
            existingCouponDiscountsCount: this.couponDiscounts.length,
            hasIncomingPayload: !!coupons,
            templateId: this.template ? this.template.id : null,
            discountsLoaded: this.discountsLoaded,
            areCouponDiscountsDirty: this.areCouponDiscountsDirty,
          };

          console.warn('[APP-5100] processCouponDiscounts called with empty payload — existing coupon discounts will be wiped:', metadata);

          if ($window.Bugsnag) {
            $window.Bugsnag.notify(
              new Error('[APP-5100] processCouponDiscounts called with empty payload — existing coupon discounts will be wiped'),
              function (event) {
                event.context = 'templates.pricing.coupons.coupons_wiped_on_update';
                event.severity = 'warning';
                event.addMetadata('couponsState', metadata);
              }
            );
          }
        }

        this.savedCouponDiscounts = coupons;
        this.couponDiscounts = [];
        for (i=0,ii=this.savedCouponDiscounts.length;i<ii;i++) {
          this.couponDiscounts.push({
            id: this.savedCouponDiscounts[i].id,
            couponCategory: this.findCouponCategory(this.savedCouponDiscounts[i].categoryId).category,
            discountCode: this.findDiscountCode(this.savedCouponDiscounts[i].discountId).code
          });
        }
        this.checkCouponDiscounts();
      },

      save: function() {
        var i, ii,
            coupons = [];

        this.validate();

        if (this.template.id && !this.wizard.hasErrors('coupons')) {
          for (i = 0, ii = this.couponDiscounts.length; i < ii; i++) {
            // Update if there is already an ID
            if (this.couponDiscounts[i] && (this.couponDiscounts[i].couponCategory || this.couponDiscounts[i].discountCode)) {
              coupons.push({
                id: this.couponDiscounts[i].id || null,
                eventTemplateId: this.template.id,
                categoryId: (this.couponDiscounts[i].couponCategory && this.couponDiscounts[i].couponCategory.id) ? this.couponDiscounts[i].couponCategory.id : null,
                discountId: (this.couponDiscounts[i].discountCode && this.couponDiscounts[i].discountCode.id) ? this.couponDiscounts[i].discountCode.id : null
              });
            }
          }

          ApiService.coupons.templates.update({
            eventTemplateId: this.template.id,
            data: coupons
          }).then(this.success.save, this.error.save);
        }
      },
      
      success: {
        getCouponCategories: function(response) {
          var self = $scope.templatesCreatePricingCoupons;

          self.couponCategories = response.data.payload.list;
          self.categoriesLoaded = true;
        },

        getCouponDiscounts: function(response) {
          var self = $scope.templatesCreatePricingCoupons;

          self.processCouponDiscounts(response.data.payload);
          self.discountsLoaded = true;
        },

        save: function(response) {}

      },
      
      error: {
        getCouponCategories: function(response) {
          var self = $scope.templatesCreatePricingCoupons;

          self.error.generic(response);
          self.categoriesLoaded = true;
        },
        getCouponDiscounts: function(response) {
          var self = $scope.templatesCreatePricingCoupons;

          self.error.generic(response);
          self.discountsLoaded = true;
        },
        save: function(response) {
          $scope.templatesCreatePricingCoupons.error.generic(response);
        },
        generic: function(response) {
          $scope.$emit('TemplatesCreateController::Error', { message: response.data.error });
        }
      },
      
      onTemplatesCreateControllerSave: function(e, data) {
        var self = $scope.templatesCreatePricingCoupons;

        if (self.discountsLoaded && self.categoriesLoaded) {
          self.save();
        } else {
          // APP-5100: Diagnostic — coupon discounts were NOT saved during this save broadcast
          // because loading flags weren't ready. Same race condition as member rules.
          var metadata = {
            discountsLoaded: self.discountsLoaded,
            categoriesLoaded: self.categoriesLoaded,
            templateId: self.template ? self.template.id : null,
          };

          console.warn('[APP-5100] Coupon discounts skipped during save — loading flags not ready:', metadata);

          if ($window.Bugsnag) {
            $window.Bugsnag.notify(
              new Error('[APP-5100] Coupon discounts skipped during save — loading flags not ready'),
              function (event) {
                event.context = 'templates.pricing.coupons.save_skipped';
                event.severity = 'warning';
                event.addMetadata('couponsState', metadata);
              }
            );
          }
        }
      },

      onDiscountsServiceUpdate: function(e, data) {
        var self = $scope.templatesCreatePricingCoupons;
        self.discountCodes = DiscountsService.getModel();
        self.discountsLoaded = true;
        self.validate();
      },

      onTemplatesServiceUpdate: function(e, data) {
        var self = $scope.templatesCreatePricingCoupons;

        self.template = TemplatesService.getModel();

        // Next Tick
        $timeout(function() {
          self.getCouponDiscounts();
        }, 0);
      },

      onTemplatesCreatePricingUpdate: function(e, data) {
        var self = $scope.templatesCreatePricingCoupons;

        if (data.view === 'coupons') {
          self.template = TemplatesService.getModel();

          // Next Tick
          $timeout(function () {
            self.getCouponDiscounts();
          }, 0);
        }
      }

    };

    $scope.templatesCreatePricingCoupons.init();

}]);